import {
  HelpCenterActionTypes,
  HelpCenterState,
  SET_INITIAL_STATE,
  SET_LOCALE,
} from "./types";

const initialState: HelpCenterState = {
  currentLocale: null,
  helpCenter: null,
  customDomainEnabled: false,
};

export default (
  state = initialState,
  action: HelpCenterActionTypes
): HelpCenterState => {
  switch (action.type) {
    case SET_INITIAL_STATE:
      return {
        ...state,
        ...action,
      };
    case SET_LOCALE:
      return {
        ...state,
        currentLocale: action.locale,
      };
    default:
      return state;
  }
};
